import * as channelsRoutines from './channelRoutines';
import * as ui_actionTypes from '../../redux/ui/actionTypes';
import { string } from 'prop-types';
import produce from 'immer';
import config from '../../globals/config'
const initialState = {
    channels: {},
    editing: false,
    form: {
        file: null, //Holds temporary file object while working in the form
        file_loading: false,
        file_selected: false,
        name: string,
    },
};

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case channelsRoutines.clearChannelData.TRIGGER:
            return produce(state, draft => {
                draft.channels = [];
            });

        case channelsRoutines.syncChannels.SUCCESS:
            return produce(state, draft => {
                draft.channels = (action.payload && action.payload.channels) || {};
            });

        case channelsRoutines.updateChannelName.SUCCESS:
            return produce(state, draft => {
                draft.form.name = action.name;
            });

        case ui_actionTypes.CLEAR_FORM:
            return produce(state, draft => {
                draft.form.file_url = null;
                draft.form.loading = false;
                draft.form.name = '';
                draft.editing = false;
                draft.distinct_users = [];
                draft.form.imageURL = config.REACT_APP_DEFAULT_CHANNELS_BACKGROUND_IMG_URL;
            });

        case ui_actionTypes.SET_CHANNEL_EDITING: //indicate editing & active channel
            return produce(state, draft => {
                draft.editing = action.channel_id;
            });

        default:
            return state;
    }
}
